module.exports = __webpack_public_path__ + "img/donante-universidad-xochicalco.ddd4efcf.jpeg";